const tr = {
    login: "Giriş",
    logout: "Çıkış",
    signIn: "Oturum aç",
    signOut: "Çıkış yap",
    profile: "Profil",
    settings: "Ayarlar",
    digiAirMenuWaiterLogin: "DigiAirMenu garson girişi",
    username: "Kullanıcı adı",
    password: "Şifre",
    pinCode: "PIN kodu",
    yourAuthenticationFailed: "Kimlik doğrulama başarısız oldu",
    language: "Dil",
    chooseLanguage: "Dil seç",
    pageNotFound: "Sayfa bulunamadı",
    backToDashboard: "Gösterge paneline dön",
    currentTable: "Mevcut tablo",
    table: "Masa",
    tables: "Masalar",
    order: "Sipariş",
    orders: "Siparişler",
    option: "Seçenek",
    additive: "Ek",
    options: "Seçenekler",
    additives: "Ekler",
    empty: "Boş",
    untitledItem: "Başlıksız",
    createdAt: "Oluşturulma",
    free: "Ücretsiz",
    items: "öğeler",
    item: "öğe",
    itemsCountOfAll: "{{payCount}} / {{maxCount}}",
    minimum: "minimum",
    maximum: "maksimum",
    all: "Tümü",
    unitPrice: "Birim fiyatı",
    email: "E-posta",
    print: "Yazdır",
    printingFailed: "Yazdırma başarısız oldu!",
    orderDetails: "Sipariş detayları",
    noOrders: "Sipariş yok",
    noOrdersAdded: "Eklenmiş sipariş yok",
    noAddedItems: "Eklenmiş öğe yok",
    loading: "Yükleniyor",
    createOrSelectOrderAfterSelectingTable: "Önce masa seçin, sonra sipariş oluşturun/seçin",
    createOrSelectOrderFirst: "Önce sipariş oluşturun/seçin",
    customFood: "Özel öğe",
    customFoods: "Özel öğeler",
    normalFoodOrDrink: "normal yemek/içecek",
    sentToKitchen: "Mutfağa gönderildi",
    sendToKitchen: "Mutfağa gönder",
    orderDelivered: "Sipariş teslim edildi",
    type: "tür",
    status: "durum",
    paid: "ödendi",
    partiallyPaid: "Kısmen ödendi",
    unpaid: "ödenmedi",
    pending: "Beklemede",
    canceled: "İptal edildi",
    created: "Oluşturuldu",
    accepted: "Kabul edildi",
    completed: "Tamamlandı",
    total: "Toplam",
    editOrderItem: "Sipariş öğesini düzenle",
    chooseTable: "Masa seç",
    pickup: "Gel al",
    suspended: "Askıda",
    processing: "Hazırlanıyor",
    rejected: "Reddedildi",
    delivered: "Teslim edildi",
    ordersList: "Sipariş listesi",
    showOlderOrders: "Eski siparişleri göster",
    showHistory: "Geçmişi göster",
    showCanceledOrders: "İptal edilen siparişleri göster",
    showDeliveredOrders: "Teslim edilen siparişleri göster",
    showPaidOrders: "Ödenen siparişleri göster",
    addNewOrder: "Yeni sipariş ekle",
    ordering: "Sipariş alma",
    availableFoods: "Mevcut öğeler",
    searchByTableName: "Masa adına göre ara",
    gridView: "Izgara görünümü",
    listView: "Liste görünümü",
    Filters: "Filtreler",
    availableItems: "Mevcut öğeler",
    searchByFoodName: "Yemek adına göre ara",
    allCategories: "Tüm kategoriler",
    noCategories: "Kategori yok",
    addFood: "Öğe ekle",
    editManualItem: "Manuel öğeyi düzenle",
    addManualItem: "Manuel öğe ekle",
    manualItem: "Manuel öğe",
    manualItems: "Manuel öğeler",
    sendEmail: "E-posta gönder",
    send: "Gönder",
    resendPaymentLink: "Ödeme bağlantısını yeniden gönder",
    iUnderstand: "Anladım",
    no: "Hayır",
    yes: "Evet",
    cancel: "İptal",
    close: "Kapat",
    back: "Geri",
    next: "İleri",
    previous: "Önceki",
    add: "Eklemek",
    preview: "Önizleme",
    changeTable: "Masa değiştir",
    saveChanges: "Değişiklikleri kaydet",
    confirm: "Onayla",
    selectAll: "Tümünü seç",
    unselectAll: "Tüm seçimi kaldır",
    clear: "Temizle",
    accept: "Kabul et",
    acceptOrder: "Siparişi kabul et",
    confirmOrder: "Siparişi onayla",
    rejectOrder: "Siparişi reddet",
    pay: "Öde",
    payment: "Ödeme",
    payments: "Ödemeler",
    paymentOf: "Ödemesi",
    itemsToPay: "Ödenecek öğeler",
    price: "Fiyat",
    totalPrice: "Toplam fiyat",
    discount: "İndirim",
    tip: "Bahşiş",
    payByCreditCard: "Kredi kartıyla öde",
    payInCash: "Nakit öde",
    checkout: "Kasa",
    transaction: "İşlem",
    transactionDetails: "İşlem detayları",
    paymentType: "Ödeme türü",
    paymentStatus: "Ödeme durumu",
    totalAmount: "Toplam tutar",
    openPayments: "Açık ödemeler",
    openPaymentsReport: "Açık ödemeler raporu",
    thisItemPaymentIsAwaitingConfirmation: "Bu öğenin ödemesi onay bekliyor",
    yourOrderPaymentIsAwaitingConfirmation: "Bu siparişte onay bekleyen bir ödeme var",
    editableInTime: "{{minutes}}dk {{seconds}}sn içinde düzenlenebilir",
    generalSettings: "Genel ayarlar",
    printMethod: "Yazdırma yöntemi",
    printMethodBrowser: "Tarayıcı yazdırma penceresi",
    printMethodBluetooth: "Bluetooth yazıcı",
    printMethodUsb: "USB yazıcı (deneysel)",
    printMethodExternal: "Harici yazıcı / uygulama",
    autoPrint: "Otomatik yazdır",
    virtualKeyboard: "Sanal klavye",
    delivery: "Teslimat",
    deliveryAddress: "Teslimat adresi",
    deliveryDetails: "Teslimat detayları",
    addDeliveryDetails: "Teslimat detayları ekle",
    editDeliveryDetails: "Teslimat detaylarını düzenle",
    createDelivery: "Teslimat oluştur",
    fullAddress: "Tam adres",
    postalCode: "Posta kodu",
    houseNumber: "Bina no",
    doorNumber: "Kapı no",
    floor: "Kat",
    fullName: "Ad soyad",
    phoneNumber: "Telefon numarası",
    deliverySummary: "Teslimat özeti",
    Error: "Hata",
    unexpectedErrorOccurred: "Bir hata oluştu",
    distance: "Mesafe",
    duration: "Süre",
    minutes: "Dakika",
    deliveryPrice: "Teslimat ücreti",
    deliveryFee: "Teslimat bedeli",
    itemsPrice: "Öğe tutarı",
    totalReceipt: "Fiş toplamı",
    customer: "Müşteri",
    pickupDetails: "Teslim alma detayları",
    pickupDate: "Teslim alma tarihi",
    pickupTime: "Teslim alma saati",
    orderId: "Sipariş ID",
    orderStatus: "Sipariş durumu",
    waiter: "Garson",
    fromCustomerApp: "Müşteri uygulamasından",
    orderType: "Sipariş türü",
    sendDelivery: "Teslimatı gönder",
    requestCourier: "Kurye iste",
    callCourier: "Kuryeyi ara",
    somethingWentWrong: "Bir şeyler ters gitti",

    appLogoAlt: "digiAirMenu logosu",
    addDAMToHomeScreen: "DigiAirMenu'yu ana ekrana ekle",
    addToHomeScreen: "Ana ekrana ekle",
    installDAM: "DAM yükle",
    transferToDemo: "Demoya aktar",
    transferToLive: "Canlıya aktar",
    row: "Satır",
    count: "adet",
    step: "adım",
    title: "Başlık",
    freeItems: "ücretsiz öğeler",
    min: "min",
    max: "maks",
    checkoutPrintDataUnavailable: "Ödeme fişi verileri yazdırma için uygun değil",
    printUsingExternalDevice: "Harici cihazla yazdır",
    customMenuItems: "Özel menü öğeleri",
    orderDeliveredConfirmation: "Bu siparişin teslim edildiğinden emin misiniz?",
    selectItemsForSendingToKitchen: "Mutfağa gönderilecek öğeleri seç",
    ItemDetailsAndStatus: "Öğe detayları / durumu",
    description: "açıklama",
    typeAnythingYouNeed: "İhtiyacınız olan her şeyi yazın",
    arrival: "Varış",
    late_arrival: "Geç varış",
    late_pickup: "Geç teslim alma",
    request_new_driver: "Yeni sürücü iste",
    shipment_destroyed: "Gönderi zarar gördü",
    address_not_found: "Adres bulunamadı",
    late_completed: "Geç tamamlandı",
    isPaid: "Ödendi",
    listOfOrders: "Sipariş listesi",
    listOfolderOrRejectedOrdersTitle: "Eski/Reddedilen",
    Layout: "Yerleşim",
    areYouSureYouWantToConvertOrderToDemoModeOrder: "<1>{{orderId}}</1> numaralı siparişi demo siparişe dönüştürmek istediğinizden emin misiniz?",
    areYouSureYouWantToConvertOrderToLiveModeOrder: "<1>{{orderId}}</1> numaralı siparişi canlı siparişe dönüştürmek istediğinizden emin misiniz?",
    areYouSureYouWantToSwitchToLiveMode: "Canlı moda geçmek istediğinizden emin misiniz?",
    areYouSureYouWantToSwitchToDemoMode: "Demo moda geçmek istediğinizden emin misiniz?",
    areYouWantDeleteThisItem: "Bu öğeyi silmek istediğinizden emin misiniz?",
    areYouWantCancelOrder: "Bu siparişi iptal etmek istediğinizden emin misiniz?",
    getEmailLabel: "Lütfen e-postanızı girin",
    enterValidEmailErr: "Lütfen geçerli bir e-posta girin.",
    sendReceiptInfo: "Fiş detaylarını gönder",
    sendMenuSms: "Menü linki gönder",
    sendMenuLinkBySms: "Menü linkini SMS ile gönder",
    menuLinkSentSuccessfully: "Menü linki başarıyla gönderildi",
    paymentLinkResentSuccessfully: "Ödeme linki başarıyla gönderildi",
    receiverEmail: "Alıcı e-postası",
    receiverPhone: "Alıcı telefonu",
    receiverEmailPlaceholder: "ornek@email.com",
    emailIsRequired: "E-posta zorunludur",
    phoneNumberIsRequired: "Telefon numarası zorunludur",
    emailOrPhoneIsRequired: "E-posta veya telefon numarası zorunludur",
    invalidEmailFormat: "Geçersiz e-posta formatı",
    selected: "seçili",
    reset: "Sıfırla",
    mobileKeyboard: "Mobil klavye",
    externalDeliveryOrder: "Harici teslimat siparişi",
    externalDeliveryOrderDescription: "Bu sipariş işlenmeden önce kabul edilmelidir",
    waiterDraftOrder: "Garsonun oluşturduğu sipariş",
    waiterDraftOrderDescription: "Bu siparişi hâlâ düzenleyebilirsiniz. Her şey netleştiğinde onaylayın.",
    completeOrderSetup: "Sipariş kurulumunu tamamla",
    completeOrderSetupDialogTitle: "Teslimat detaylarını tamamlayın ve sipariş zamanlamasını kesinleştirin",
    acceptOrderDialogTitle: "Bu siparişi kabul etmek hazırlığı başlatır ve mutfağı bilgilendirir",
    confirmOrderDialogTitle: "Bu siparişi onaylamak değişiklikleri kilitler ve hazırlığı başlatır",
    acceptOrderExternalDescription: "Bu sipariş harici olarak geldi. Hazırlığı başlatmak için kabul edin veya karşılayamıyorsanız reddedin.",
    confirmOrderWaiterCreatedDescription: "Bu sipariş garson tarafından oluşturuldu. Tüm öğeler hazır olduğunda kontrol edip onaylayın.",
    acceptOrderWaiterCreatedDescription: "Bu sipariş garson tarafından oluşturuldu. Değişiklikleri kilitlemek ve hazırlığı başlatmak için kabul edin.",
    editingLockedForCustomerOrder: "Müşteri siparişlerinde düzenleme kilitlidir.",
    editingLockedForRejectedOrder: "Bu sipariş reddedildiği için düzenleme kilitlidir.",
    editingLockedCustomerOrderAfterAcceptance: "Müşteri siparişlerinde kabulden sonra düzenleme kilitlenir.",
    editingLockedAfterConfirmation: "Sipariş onaylandıktan sonra düzenleme kilitlenir.",
    editingDoneOrderItemLocked: "Tamamlanmış öğeler artık değiştirilemez.",
    editingPaidOrderItemLocked: "Ödenmiş öğeler artık değiştirilemez.",
    editingPendingPaymentOrderItemLocked: "Ödemesi işlenirken bu öğe değiştirilemez.",
    editingSentToKitchenItemLockedByPermission: "Mutfağa gönderilmiş öğeleri değiştirme izniniz yok.",
    rejectOrderConfirm: "Bu siparişi reddetmek istediğinizden emin misiniz?",
    acceptOrderPickupTimeHelperText: "Teslim alma saatini en fazla <1>30 dakika</1> erteleyebilirsiniz",
    pleaseEnterPickupTime: "Lütfen teslim alma saati girin",
    addToOrders: "siparişlere ekle",
    cancelThisOrder: "Bu siparişi iptal et",
    cancelOrder: "Siparişi iptal et",
    orderModeChangedToDemoInJSX: "İstenen sipariş modu '<1>Sipariş {{targetOrderId}}</1>' başlığıyla demo moduna değiştirildi.",
    orderModeChangedToLiveInJSX: "İstenen sipariş modu '<1>Sipariş {{targetOrderId}}</1>' başlığıyla canlı moda değiştirildi.",
    checkoutHasPaidByPosInJSX: "<1>Kasa işlemi</1> id <3>{{checkout_id}}</3>, <5>sipariş {{order_id}}</5> içinden POS ile başarıyla ödendi.",
    demo: "Demo",
    demoModeIsActive: "Demo modu aktif",
    demoModeAlertMessage: "Demo Modu yalnızca eğitim ve test amaçlıdır. Demo Modu aktifken, sistemin kullanımı ve geçerli tüm yasal düzenlemelere uyulması tamamen restoran işletmecisinin sorumluluğundadır.",
    normal: "Normal",
    showOrderInTargetMode: "Siparişi {{targetMode}} modunda göster",
    showOrder: "Siparişi göster",
    openOrderInBackground: "<0>Aç</0> <1>(arka planda)</1>",
    incomingOrderNotificationTitle: "Yeni sipariş alındı",
    incomingOrderNotificationDescription: "Bir müşteri siparişi geldi. Bu pencereyi kapatmadan arka planda açmak için aşağıdaki düğmeyi kullanın.",
    yesDeleteIt: "Evet, sil",
    payReport: "Ödeme raporu",
    checkoutOperation: "Kasa işlemi",
    basicPrice: "Temel fiyat",
    baseAmount: "Temel tutar",
    paidPrice: "Ödenen tutar",
    paidBy: "Ödeyen",
    discountAmount: "İndirim tutarı",
    tipPrice: "Bahşiş tutarı",
    totalWithTip: "Bahşişli toplam",
    amountToPay: "Ödenecek tutar",
    paymentAmount: "Ödeme tutarı",
    paymentsIncludingDiscounts: "İndirimler dahil ödemeler",
    paymentsExcludingDiscounts: "İndirimler hariç ödemeler",
    paymentsTakingIntoAccountTheirDiscount: "İndirimi dikkate alınan ödemeler",
    paymentsRegardlessOfTheirDiscount: "İndirimi dikkate alınmayan ödemeler",
    openPaymentsStatistics: "Açık ödemeler istatistikleri",
    discountCannotBeLessThanZero: 'İndirim tutarı "0"dan az olamaz',
    discountCannotBeNegative: "İndirim tutarı negatif olamaz",
    discountCannotBeMoreThanHundredPercent: 'İndirim tutarı "%100"den fazla olamaz',
    discountCannotBeMoreThan: "İndirim tutarı {{price}} değerinden fazla olamaz",
    theValueMustBeMoreThan: "Değer {{price}} değerinden fazla olmalıdır",
    theValueMustBeMoreThanBaseAmount: "Değer temel tutardan fazla olmalıdır",
    valueMustBeLessThanOrEqualToMessage: "Değer {{maxPrice}} değerinden küçük veya ona eşit olmalıdır",
    valueMustBeGreaterThanZeroMessage: "Değer 0'dan büyük olmalıdır",
    tipAmount: "Bahşiş tutarı",
    tipCannotBeNegative: "Bahşiş tutarı negatif olamaz",
    cardTransfer: "Kart transferi",
    noTransactionHasBeenMade: "Hiç işlem yapılmadı",
    backToTransactionsList: "İşlem listesine dön",
    transactionsHistory: "İşlem geçmişi",
    transactionId: "İşlem ID",
    transactionHasBeenSentToYourEmail: "İşlem e-postanıza gönderildi",
    ordersPrice: "Sipariş tutarı",
    updatedAt: "Güncellendi",
    fromTime: "Başlangıç",
    toTime: "Bitiş",
    backToOrders: "Siparişlere dön",
    tablesList: "Masa listesi",
    backToTablesList: "Masa listesine dön",
    showDetails: "Detayları göster",
    receiptDetailsPage: "Fiş detayları sayfası",
    checkoutQrCodeAlt: "Kasa QR kodu",
    vat: "KDV",
    net: "Net",
    tax: "Vergi",
    gross: "Brüt",
    sendingEmailFailed: "E-posta gönderilemedi!",
    paymentFailed: "Ödeme başarısız",
    Open_Payments: "Açık ödemeler",
    report: "Rapor",
    openPaymentStatistics: "Açık ödeme istatistiği",
    allOrderItemsHaveBeenPaid: "Bu siparişteki tüm öğeler ödendi",
    noItemsHaveBeenAddedInThisOrder: "Bu siparişe hiç öğe eklenmedi",
    thisItemHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "Bu öğe POS ile ödendi ve ödeme onayı bekliyor",
    yourOrderHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "Siparişiniz POS ile ödendi ve ödeme onayı bekliyor",
    customItems: "Özel öğeler",
    singlePrintMethodDescription: "Aynı anda yalnızca bir yazdırma yöntemi aktiftir",
    bluetoothUnavailable: "Bluetooth bu tarayıcıda veya cihazda kullanılamıyor",
    bluetoothSecureContextRequired: "Bluetooth yazdırma HTTPS veya localhost gerektirir",
    bluetoothPrinterNotSupported: "Seçilen Bluetooth yazıcı desteklenmiyor",
    noBluetoothPrinterSelected: "Bluetooth yazıcı seçilmedi",
    noCompatibleBluetoothPrinterFound: "Uyumlu Bluetooth yazıcı bulunamadı veya seçilmedi. Tarayıcılar genellikle yalnızca BLE/GATT yazıcıları algılar, bu nedenle Epson TM-m30 gibi klasik Bluetooth modelleri burada görünmeyebilir",
    bluetoothAutoPrintRequiresSelection: "Otomatik yazdırma kullanılmadan önce bir Bluetooth yazıcıyı bir kez manuel seçin",
    bluetoothPrintingNotSupported: "Bluetooth yazdırma bu tarayıcıda veya cihazda desteklenmiyor",
    usbUnavailable: "USB bu tarayıcıda veya cihazda kullanılamıyor",
    usbSecureContextRequired: "USB yazdırma HTTPS veya localhost gerektirir",
    noCompatibleUsbPrinterFound: "Uyumlu USB yazıcı bulunamadı veya seçilmedi",
    usbAccessDenied: "Tarayıcı veya işletim sistemi seçilen USB yazıcıya erişimi reddetti. Diğer yazıcı uygulamalarını kapatın ve sistem USB izinlerini kontrol edip tekrar deneyin",
    usbAutoPrintRequiresSelection: "Otomatik yazdırma kullanılmadan önce bir USB yazıcıyı bir kez manuel seçin",
    usbPrintingNotSupported: "USB yazdırma seçilen cihaz için desteklenmiyor",
    printerSize: "Yazıcı boyutu",
    useExternalPrinter: "Harici yazıcı kullan",
    bluetoothPrinterDetails: "Bluetooth yazıcılara çıktı gönderebilir veya bu cihazdaki bağlı yazıcılardan birini seçmek için kapatabilirsiniz",
    usbPrinterDetails: "Masaüstü Chrome veya Edge'de ESC/POS uyumlu USB yazıcılar için deneysel destek. Otomatik yazdırmanın kullanabilmesi için yazıcıyı bir kez manuel seçmeniz gerekebilir. Windows'ta yazıcının tarayıcı listesinde görünmesi için Vendor Class modu ve WinUSB uyumlu sürücü gerekebilir",
    externalPrinterDetails: "Uygulamaya bağlı harici yazıcılara çıktı gönderebilir veya bu cihazdaki bağlı yazıcılardan birini seçmek için kapatabilirsiniz",
    autoPrintDescription: "Sipariş kabul edildikten veya ödenmiş sipariş websocket olayı geldikten sonra otomatik yazdır",
    autoPrintUnavailableForBrowserDescription: "Tarayıcı yazdırma penceresi kullanılırken otomatik yazdırma kullanılamaz",
    browserPrintMethodNotice: "Tarayıcı yazdırma penceresi her zaman onay ister, bu yüzden fişler otomatik yazdırılamaz",
    selectAllPayablesByDefault: "Tüm ödenebilirleri varsayılan olarak seç",
    selectAllPayablesByDefaultOnThePaymentPage: "Ödeme sayfasında tüm ödenebilir öğeleri varsayılan olarak seç",
    virtualKeyboardDescription: "Desteklenen form alanlarında uygulama içi klavyeyi kullan",
    virtualKeyboardInfoLabel: "Klavye yardımı",
    virtualKeyboardDisableHint: "Cihaz klavyenizi tercih ediyorsanız, bu klavyeyi <0>Ayarlar</0> içinden kapatabilirsiniz.",
    served: "Servis edildi",
    apartmentEntrance: "Apartman girişi",
    extraAddressDetails: "Ek adres detayları",
    dialCode: "Ülke kodu",
    contactInformationAtPickup: "Alıcı iletişim bilgileri",
    recommended: "önerilir",
    successfulDeliveryRegistration: "Teslimat başarıyla kaydedildi",
    successfulSendDelivery: "Teslimat başarıyla gönderildi",
    withDelivery: "Teslimatlı",
    deliveryItem: "Teslimat öğesi",
    pickupDatetime: "İstenen teslim alma tarihi/saati",
    pickupTimeLabel: "Teslim alma saati ({{format}})",
    pickupTimeBaseLabel: "Temel teslim alma saati",
    pickupTimeFinalLabel: "Son teslim alma saati",
    dropOffTime: "Bırakma saati",
    requestedPickupDatetime: "Mevcut istenen teslim alma tarihi/saati",
    timePickerHour: "Saat",
    timePickerMinute: "Dakika",
    toggleTimeList: "Saat listesini aç/kapat",
    pickupTimeInitialShort: "Temel",
    orderTiming: "Sipariş zamanlaması",
    maximumSelectableFreeCountHint: "Ücretsiz seçilebilecek maksimum adet",
    minimumSelectableCountHint: "Seçilebilir minimum adet",
    maximumSelectableCountHint: "Seçilebilir maksimum adet",
    maximumSelectedItemsReached: "Seçilen öğe sayısı maksimuma ulaştı",
    changePickupTime: "Teslim alma saatini değiştir",
    pickupTimeAllowedRangeHint: "{{date}} için teslim alma saati {{start}} ile {{end}} arasında seçilebilir.",
    pickupDatetimeNotSetHint: "Henüz teslim alma tarihi/saati ayarlanmadı. Herhangi bir teslim alma saati seçebilirsiniz.",
    pickupDatetimeLimitedDelayHint: "Bu istenen teslim alma tarihi/saati, sipariş kabul beklerken en fazla <1>30 dakika</1> ertelenebilir.",
    pickupDatetimeLockedHint: "Bu sipariş için teslim alma tarihi/saati zaten ayarlanmış.",
    pickupTimeEditableOnlyWhenSuspended: "Teslim alma saati yalnızca sipariş askıdayken değiştirilebilir.",
    pleaseEnterPickupDate: "Lütfen teslim alma tarihi girin",
    pickupDateMustBeTodayOrTomorrow: "Garson tarafından oluşturulan siparişlerde teslim alma tarihi bugün veya yarın olmalıdır.",
    normalOrderCreationUnavailableTitle: "Normal siparişler şu anda kullanılamıyor",
    normalOrderCreationClosedAllDay: "Restoran bugün kapalı, bu yüzden sipariş oluşturulamaz.",
    normalOrderCreationClosedAtThisTime: "Restoran şu anda kapalı. Siparişler çalışma saatlerinde oluşturulabilir: {{hours}}.",
    waiterOrderNoAvailableOpenSlot: "Şu anda izin verilen tarihlerde restoran çalışma saatleri içinde geçerli bir {{orderType}} saati yok.",
    pickupDateOutsideOpeningHours: "Seçilen tarih {{orderType}} siparişleri için izin verilen açılış günlerinin dışında.",
    pickupTimeOutsideOpeningHours: "Seçilen saat {{orderType}} siparişleri için izin verilen çalışma saatlerinin dışında.",
    openingHoursSelectableRangeHint: "{{date}} için {{orderType}} saati {{start}} ile {{end}} arasında seçilebilir.",
    openingHoursClosedDayHint: "{{date}}, {{orderType}} siparişleri için kapalı.",
    openingHoursClosedDayCalendarHint: "Bu sipariş türü için kapalı",
    openingHoursDisabledDatesHint: "Yalnızca restoran çalışma saatleri içinde en az bir uygun {{orderType}} saati olan tarihler seçilebilir.",
    openingHoursUnavailableTimesHint: "Seçilemeyen saatler, seçilen tarihte {{orderType}} siparişleri için restoran çalışma saatlerinin dışındadır.",
    payByLink: "Link ile öde",
    updateDelivery: "Teslimatı güncelle",
    sendCourierRequest: "Kurye talebi gönder",
    sentToCourier: "Kuryeye gönderildi",
    noPickupTimeProvidedForThisOrder: "Bu sipariş için teslim alma saati verilmedi",
    pickupTimeCalculationForThisOrderFailed: "Bu sipariş için teslim alma saati hesaplanamadı",
    itemEditFailed: "Ürün düzenlenemedi",
    thisItemCannotBeEdited: "Bu ürün düzenlenemez.",
    problemInReadingItemEssentialDataMessage: "Ürünün temel bilgileri okunurken bir sorun oluştu",
};

export default tr;
